// extracted by mini-css-extract-plugin
export default {"divider":"AddressComponent_divider__Yq8tJ","inputNumber":"AddressComponent_inputNumber__JRqPQ"};